export default "__VITE_ASSET__BAIJxVJm__"